import { useMutation } from '@tanstack/react-query';

import { postDashboard } from './dashboards';
import type { CreateDashboardPayload } from './dashboards.types';

export const useCreateDashboard = () => {
  return useMutation({
    mutationFn: (
      payload: Omit<CreateDashboardPayload, 'sharingScope' | 'description'>,
    ) => {
      return postDashboard({
        ...payload,
        sharingScope: 'Private',
        description: '',
      });
    },
    onSuccess: (_data) => {
      // TODO: Add tracking
    },
  });
};
